import classNames from 'classnames';
import type { SVGProps, JSX } from 'react';

export type Props = {
  readonly icon: (props: SVGProps<SVGSVGElement>) => JSX.Element;
  readonly tone?: 'accent' | 'neutral' | 'warning';
  readonly className?: string;
};

const toneClass = {
  accent: 'bg-accent-soft text-accent-soft-foreground',
  neutral: 'bg-default text-foreground',
  warning: 'bg-warning-soft text-warning-soft-foreground',
} as const;

const IconTile = ({ icon: Icon, tone = 'accent', className }: Props) => (
  <div
    aria-hidden="true"
    className={classNames(
      'grid size-12 shrink-0 place-items-center rounded-2xl',
      toneClass[tone],
      className
    )}
  >
    <Icon className="size-6" />
  </div>
);

export default IconTile;
